import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Autotext, PolicyForm, Test } from "@app/definitions/types"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { PolicyFormInviteComponent } from "@app/policy-form-invite/policy-form-invite.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { UpdatePolicyFormComponent } from "@app/update-policy-form/update-policy-form.component"

@Component({
	selector: "app-policy-forms-menu",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		PolicyFormInviteComponent,
		ModalWrapComponent,
		UpdatePolicyFormComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./policy-forms-menu.component.html",
})
export class PolicyFormsMenuComponent extends Modalable {
	modalProps: any = null
	policyForms: PolicyForm[] = [] //the list of current autoTexts
	curOpenId: number = 0

	ngOnInit() {
		this.getItems()
	}

	getItems() {
		this.policyForms = this.store.getSiteDataTable("policy_forms").map((it) => {
			return {
				...it,
				latestVersion: this.store.getSortedVersions(it.id)?.at(0),
			}
		})
	}

	openInvite(row: PolicyForm) {
		if (this.curOpenId === row.id) {
			this.curOpenId = 0
			return
		}
		if (!row.latestVersion) {
			this.modalService.openToast("no_versions")
			return
		}
		this.curOpenId = row.id
	}
	async openUpdate(policyForm: PolicyForm) {
		this.modalProps = { name: "update-policy-form", policyForm }
	}
}
